import { createFileRoute } from "@tanstack/react-router";

import { AccountPanel } from "@/features/accounts/pages";
import { parsePersonSearch } from "@/features/specialists";
import { SpecialistPage } from "@/features/specialists/pages";
import { strictSearch } from "@/shared/lib/search";

export const Route = createFileRoute("/_app/specialists/$userId")({
  validateSearch: strictSearch(parsePersonSearch),
  component: Specialist,
});

function Specialist() {
  const { userId } = Route.useParams();
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  // Keyed by the person: going from one specialist to another starts the page anew.
  // The account is hg-auth's, kept by another feature: the route puts the two on one page.
  return (
    <SpecialistPage
      key={userId}
      userId={userId}
      search={search}
      onSearchChange={(next) => void navigate({ search: next, replace: true })}
      account={<AccountPanel key={userId} userId={userId} />}
    />
  );
}
